import {
  AccordionSummary,
  Icon,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, _, classes) => ({
  root: {
    padding: 0,
    display: 'flex',
    alignItems: 'flex-start',

    [`&.${classes.expanded}`]: {
      minHeight: theme.spacing(6),
    },
  },
  content: {
    margin: theme.spacing(0, 0, 2, 0),

    [`&.${classes.expanded}`]: {
      margin: theme.spacing(0, 0, 1, 0),
    },
  },
  expanded: {},
  expandIcon: {
    padding: '4px 12px 4px 12px',
  },
}));

const Summary = ({ children, ...props }) => {
  const {classes} = useStyles();

  return (
    <AccordionSummary
      expandIcon={<Icon>expand_less</Icon>}
      classes={classes}
    >
      {children}
    </AccordionSummary>
  );
};

export default Summary;
